import { createAction, handleActions } from 'redux-actions';
import { api, getSource } from '../utils/knreise';
import { instanceUrl } from '../utils/article';
import superagent from 'superagent';
import { olUtils } from 'react-openlayers';
import { containsCoordinate } from 'ol/extent'; // ------------------------------------
// Constants
// ------------------------------------

export var LOAD_ARTICLES = 'LOAD_ARTICLES';
export var LOADING_SOURCE = 'LOADING_SOURCE';
export var RELOAD_DATA = 'RELOAD_DATA';
export var ARTICLE_LOADING = 'ARTICLE_LOADING';
export var ARTICLE_LOADED = 'ARTICLE_LOADED';
export var SET_ACTIVE_SOURCES = 'SET_ACTIVE_SOURCES';
export var LOAD_THEME_ARTICLES = 'LOAD_THEME_ARTICLES';
export var THEME_ARTICLE_LOADED = 'THEME_ARTICLE_LOADED';
export var RESET_LOAD_STATE = 'RESET_LOAD_STATE'; // ------------------------------------
// Actions
// ------------------------------------

var setActiveSources = createAction(SET_ACTIVE_SOURCES, function (activeSources) {
  return {
    activeSources: activeSources
  };
});
var loadArticles = createAction(LOAD_ARTICLES, function (source, data, extent, projCode) {
  return {
    source: source,
    data: data,
    extent: extent,
    projCode: projCode
  };
});
var loadThemeArticles = createAction(LOAD_THEME_ARTICLES, function (source, articles, extent, projCode) {
  return {
    source: source,
    articles: articles,
    extent: extent,
    projCode: projCode
  };
});
var loadDimuArticles = createAction(LOAD_THEME_ARTICLES, function (source, articles, extent, projCode) {
  return {
    source: source,
    articles: articles,
    extent: extent,
    projCode: projCode
  };
});
var loadingSource = createAction(LOADING_SOURCE, function (source, mapCenter, mapZoom, filterColumns) {
  return {
    source: source,
    mapCenter: mapCenter,
    mapZoom: mapZoom,
    filterColumns: filterColumns
  };
});
var articleLoading = createAction(ARTICLE_LOADING, function (id) {
  return {
    id: id
  };
});
var articleLoaded = createAction(ARTICLE_LOADED, function (id, data, projCode, cached, dataIndex) {
  return {
    id: id,
    data: data,
    projCode: projCode,
    cached: cached,
    dataIndex: dataIndex
  };
});
var themeArticleLoaded = createAction(THEME_ARTICLE_LOADED, function (id, article, source) {
  return {
    id: id,
    article: article,
    source: source
  };
});
export var resetLoadState = createAction(RESET_LOAD_STATE);
export var loadSource = function loadSource(source, center, zoom, extent, projCode) {
  var filterColumns = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
  var pageLimit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  return function (dispatch, getState) {
    var state = getState();

    if (!center) {
      return;
    }

    dispatch(loadingSource(source, center, zoom, filterColumns));

    if (source.value.api === 'avdigitheme' || source.value.api === 'avtheme') {
      loadDigiTheme(source, filterColumns[source.dataIndex], state, extent, projCode, pageLimit, dispatch);
    } else if (source.value.api === 'dimu') {
      loadDimuData(source, extent, projCode, dispatch);
    } else if (source.cache) {
      var _bbox = olUtils.transformExtent(extent, projCode, 'EPSG:4326');

      var params = {
        start: 0,
        limit: pageLimit,
        bbox: _bbox.join(','),
        tags: source.categories.join(),
        datasource_data_index: source.dataIndex
      };
      fetch(instanceUrl() + 'WebServices/articleComments/Cache.asmx/spatialTagSearch', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(params)
      }).then(function (res) {
        return res.json();
      }).then(function (res) {
        res = res.d;

        if (res.success) {
          dispatch(loadArticles(source, res.records, extent, projCode));
        } else {
          console.error('Load cached articles failed', res);
          dispatch(loadArticles(source));
        }
      }).catch(function (e) {
        console.error('Load cached articles failed', e);
        dispatch(loadArticles(source));
      });
    } else if (zoom > 12) {
      var bbox = olUtils.transformExtent(extent, projCode, 'EPSG:4326');
      api.getBbox(source.value, bbox.join(','), function (data) {
        return dispatch(loadArticles(source, data, extent, projCode));
      }, function (data) {
        console.error('Load failed', data);
        dispatch(loadArticles(source));
      });
    } else {
      var _center = olUtils.transformCoordinate(center, projCode, 'EPSG:4326');

      var latlng = {
        lng: _center[0],
        lat: _center[1]
      };
      api.getWithin(source.value, latlng, 10000, function (data) {
        return dispatch(loadArticles(source, data, extent, projCode));
      }, function (data) {
        console.error('Load failed', data);
        dispatch(loadArticles(source));
      });
    }
  };
};
export var loadArticle = function loadArticle(id, projCode) {
  return function (dispatch, getState) {
    dispatch(articleLoading(id));
    var idParts = id.split('_');
    var sourceIdx = idParts[0];
    var sourceId = idParts.slice(1).join('_');
    var source = getSource(sourceIdx);

    if (!source) {
      dispatch(articleLoaded(id, undefined));
      return;
    }

    var apiName = source.value.api;
    var state = getState();

    if (apiName === 'avdigitheme' || apiName === 'avtheme') {
      loadThemeArticle(id, source, state, projCode, dispatch);
    } else if (apiName === 'dimu') {
      loadDimuArticle(id, source, projCode, dispatch);
    } else if (source.cache) {
      fetch(instanceUrl() + 'WebServices/articleComments/Cache.asmx/Get', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          id: apiName + '_' + sourceId
        })
      }).then(function (res) {
        return res.json();
      }).then(function (res) {
        res = res.d;

        if (res.success) {
          dispatch(articleLoaded(id, res.records[0], projCode, true, sourceIdx));
        } else {
          console.error('Load cached article failed', res);
          dispatch(articleLoaded(id, undefined));
        }
      }).catch(function (e) {
        console.error('Load cached article failed', e);
        dispatch(articleLoaded(id, undefined));
      });
    } else {
      api.getItem({
        api: apiName,
        id: id.substring(id.indexOf('_') + 1)
      }, function (data) {
        return dispatch(articleLoaded(id, data, projCode));
      }, function (e) {
        console.error(e);
        dispatch(articleLoaded(id, undefined));
      });
    }
  };
};
export var actions = {
  loadSource: loadSource,
  loadArticle: loadArticle,
  setActiveSources: setActiveSources,
  resetLoadState: resetLoadState
};

function loadDimuArticle(id, source, projCode, dispatch) {
  var urlParams = ['https://api.dimu.org/api/solr/select?q=*'];

  if (id) {
    urlParams.push('fq=(artifact.uuid:' + id.slice(id.indexOf('_') + 1) + ')');
  }

  if (source.config.apikey) {
    urlParams.push('wt=json&api.key=' + source.config.apikey);
  } else {
    urlParams.push('wt=json&api.key=' + 'demo');
  }

  superagent.get(urlParams.join('&')).set('Accept', 'application/json').set('Content-Type', 'application/json').then(function (res) {
    return res.body;
  }).then(function (res) {
    if (!res.error) {
      var article = parseDimuArticle(res.response.docs[0], source, projCode);

      if (article) {
        dispatch(themeArticleLoaded(id, article, source));
      }
    } else {
      dispatch(themeArticleLoaded(null, null, source));
    }
  }).catch(function (e) {
    console.error('Load dimu-article failed', e);
    dispatch(themeArticleLoaded(null, null, source));
  });
}

function loadThemeArticle(id, source, state, projCode, dispatch) {
  var srsProjCode = projCode.split(':')[1];
  var params = {
    request: {
      theme_uuid: source.value.uuid,
      columns: Object.keys(source.config.columns).map(function (key) {
        return source.config.columns[key];
      }).reduce(function (a, b) {
        a = a instanceof Array ? a : [a];
        b = b instanceof Array ? b : [b];
        return a.concat(b);
      }).filter(function (item) {
        if (item != null) {
          return item;
        }
      }),
      extraParams: [],
      limit: 1,
      start: 0,
      filter: {
        filterColumns: [{
          comparisonOperator: '=',
          name: source.config.columns.id,
          value: id.substring(id.indexOf('_') + 1)
        }]
      }
    }
  };
  superagent.post(instanceUrl() + 'WebServices/client/DataView.asmx/ReadAny').send(params).set('X-Adaptive-SRID', srsProjCode).set('Accept', 'application/json').set('Content-Type', 'application/json').then(function (res) {
    return res.body;
  }).then(function (res) {
    res = res.d;

    if (res.success && res.records.length > 0) {
      var article = parseThemeArticle(res.records[0], source, dispatch, srsProjCode);

      if (article) {
        dispatch(themeArticleLoaded(id, article, source));
      }
    } else {
      dispatch(themeArticleLoaded(null, null, source));
    }
  }).catch(function (e) {
    console.error('Load theme/digitheme article failed', e);
    dispatch(themeArticleLoaded(null, null, source));
  });
}

;

function parseCachedArticle(data, dataIndex, active, mapProjCode) {
  var feature = olUtils.createFeatureFromWkt(data.geom.split(';')[1]);
  var projCode = 'EPSG:' + data.geom.split(';')[0].split('=')[1];

  if (data.image) {
    data.images = [data.image];
  }

  var olFeature = feature;

  if (projCode !== mapProjCode) {
    olFeature = olUtils.createFeatureFromGeometry(feature.getGeometry().transform(projCode, mapProjCode));
  }

  olFeature.set('title', data.title);
  return {
    id: dataIndex + '_' + data.id.substring(data.id.indexOf('_') + 1),
    globalId: data.id,
    active: active,
    sources: [dataIndex],
    geometry: {
      type: feature.getGeometry().getType(),
      coordinates: feature.getGeometry().getCoordinates()
    },
    properties: data,
    olFeature: olFeature
  };
}

;

function loadDimuData(source, extent, projCode, dispatch) {
  var urlParams = ['https://api.dimu.org/api/solr/select?q=*', 'rows=100'];
  var newExtent = olUtils.transformExtent(extent, projCode, 'EPSG:4326');

  if (newExtent) {
    urlParams.push('fq=artifact.coordinate: [' + newExtent[1] + ',' + newExtent[0] + ' TO ' + newExtent[3] + ',' + newExtent[2] + ']');
  }

  urlParams.push('&dimu_instance=dimu-no prod');

  if (source.categories && source.categories.length > 0) {
    urlParams.push('fq=artifact.tag: (' + source.categories.join(' OR ') + ')');
  }

  if (source.config.apikey) {
    urlParams.push('wt=json&api.key=' + source.config.apikey);
  }

  superagent.get(urlParams.join('&')).set('Accept', 'application/json').set('Content-Type', 'application/json').then(function (res) {
    return res.body;
  }).then(function (res) {
    res = res.response;

    if (!res.error) {
      var articles = res.docs.map(function (data) {
        return parseDimuArticle(data, source, projCode);
      }).filter(function (article) {
        return !!article;
      });
      dispatch(loadDimuArticles(source, articles, extent, projCode));
    } else {
      dispatch(loadDimuArticles(source));
    }
  }).catch(function (e) {
    console.error('Load digitalt museum-articles failed', e);
    dispatch(loadDimuArticles(source));
  });
}

;

function parseDimuArticle(data, source, projCode) {
  if (!data['artifact.coordinate']) {
    return;
  }

  var feature = olUtils.createFeatureFromWkt('Point(' + data['artifact.coordinate'].split(',')[1] + ' ' + data['artifact.coordinate'].split(',')[0] + ')', {
    title: data['artifact.ingress.title']
  });
  var image = data['artifact.hasPictures'] && data['artifact.defaultMediaIdentifier'] ? 'https://mm.dimu.org/image/' + data['artifact.defaultMediaIdentifier'] : undefined;
  feature.getGeometry().transform('EPSG:4326', projCode);
  var article = {
    id: source.dataIndex + '_' + data['artifact.uuid'],
    globalId: source.value.api + '_' + data['artifact.uniqueId'],
    sources: [source.dataIndex],
    sourceId: source.value.uuid,
    geometry: {
      type: feature.getGeometry().getType(),
      coordinates: feature.getGeometry().getCoordinates()
    },
    properties: {
      title: data['artifact.ingress.title'],
      content: data['artifact.ingress.description'] || '',
      link: 'https://digitaltmuseum.no/' + data['artifact.uniqueId'],
      images: image != null || image != undefined ? [image] : null,
      provider: 'DigitaltMuseum'
    },
    olFeature: feature
  };
  return article;
}

;

function loadDigiTheme(source, externalFilterColumns, state, extent, projCode, pageLimit, dispatch) {
  var srsProjCode = projCode.split(':')[1];
  var extGeom = olUtils.createPolygonFromExtent(olUtils.bufferExtent(extent, 1.2));
  var extFeat = olUtils.createFeatureFromGeometry(extGeom);
  var wktExtent = olUtils.getWktFromFeature(extFeat);
  var filterColumns = [{
    comparisonOperator: 'ST_INTERSECTS',
    name: 'geom',
    netType: 'geometry',
    value: 'SRID=' + srsProjCode + ';' + wktExtent,
    logicalOperator: 'AND'
  }];
  var params = {
    request: {
      theme_uuid: source.value.uuid,
      columns: Object.keys(source.config.columns).map(function (key) {
        return source.config.columns[key];
      }).reduce(function (a, b) {
        a = a instanceof Array ? a : [a];
        b = b instanceof Array ? b : [b];
        return a.concat(b);
      }).filter(function (item, pos, arr) {
        if (item !== null && item !== 'geom' && item !== 'geom_wkt') {
          return arr.indexOf(item) === pos;
        }
      }),
      extraParams: [],
      limit: pageLimit,
      start: 0,
      filter: {
        filterColumns: filterColumns
      }
    }
  };

  if (externalFilterColumns !== undefined && externalFilterColumns !== null) {
    params.request.filter.defaultFilter = externalFilterColumns;
  }

  if (source.config.categoryColumn && source.config.categoryColumn !== '' && source.config.categories && source.config.categories.length) {
    params.request.filter.filterColumns.push({
      comparisonOperator: 'ANY',
      name: source.config.categoryColumn,
      netType: 'string[]',
      value: source.config.categories,
      logicalOperator: 'AND'
    });
  }

  superagent.post(instanceUrl() + 'WebServices/client/DataView.asmx/ReadAny').send(params).set('Accept', 'application/json').set('Content-Type', 'application/json').set('X-Adaptive-SRID', srsProjCode).then(function (res) {
    return res.body;
  }).then(function (res) {
    res = res.d;

    if (res.success) {
      var articles = res.records.map(function (record) {
        return parseThemeArticle(record, source, dispatch, srsProjCode);
      }).filter(function (article) {
        return !!article;
      });
      dispatch(loadThemeArticles(source, articles, extent, projCode));
    } else {
      console.error('Load theme/digitheme articles failed', res);
      dispatch(loadThemeArticles(source));
    }
  }).catch(function (e) {
    console.error('Load theme/digitheme articles failed', e);
    dispatch(loadThemeArticles(source));
  });
}

;
var vimeoCache = {};

function parseThemeArticle(data, source, dispatch, srsProjCode) {
  var columns = source.config.columns;
  var id = source.dataIndex + '_' + data[columns.id];
  var globalId = source.value.api + '/' + source.value.uuid + '_' + data[columns.id];
  var feature = olUtils.createFeatureFromWkt(data.geom_wkt);
  var image = data[columns.image];
  feature.set('title', data[columns.title]);
  var article = {
    id: id,
    globalId: globalId,
    sources: [source.dataIndex],
    sourceId: source.value.uuid,
    geometry: {
      type: feature.getGeometry().getType(),
      coordinates: feature.getGeometry().getCoordinates()
    },
    properties: {
      title: data[columns.title],
      content: data[columns.content],
      thumbnail: image
    },
    olFeature: feature
  };

  if (data.geom_extent) {
    var _feature = olUtils.createFeatureFromWkt(data.geom_extent.split(';')[1]);

    var projCode = data.geom_extent.split(';')[0].split('=')[1];
    article.extent = olUtils.transformExtent(_feature.getGeometry().getExtent(), 'EPSG:' + projCode, 'EPSG:' + srsProjCode);
  }

  source.config.columns.additionalColumns.forEach(function (colName) {
    article.properties[colName] = data[colName];
  });

  if (source.config.columns.vimeo) {
    var url = data[source.config.columns.vimeo];

    if (vimeoCache[url]) {
      article.vimeoData = vimeoCache[url];
    } else {
      superagent.get(instanceUrl() + 'proxies/xVimeoEmbed.ashx?url=' + url).then(function (res) {
        return res.body;
      }).then(function (res) {
        vimeoCache[url] = res;
        article.vimeoData = res;
        dispatch(themeArticleLoaded(id, article, source));
      });
      return;
    }
  }

  return article;
}

; // ------------------------------------
// Reducer
// ------------------------------------

export default handleActions({
  LOAD_ARTICLES: function LOAD_ARTICLES(state, _ref) {
    var payload = _ref.payload;
    var newArticles = {};

    if (!payload.data) {
      return Object.assign({}, state, {
        loading: false
      });
    } else if (payload.source.cache) {
      var currentArticles = state.articles || {};
      Object.values(currentArticles).forEach(function (article) {
        if (article.active || !article.olFeature || containsCoordinate(payload.extent, article.olFeature.getGeometry().getFirstCoordinate())) {
          newArticles[article.id] = article;
        } else if (article.olFeature) {
          delete article.olFeature;
        }
      });
      payload.data.forEach(function (data) {
        var active = newArticles[data.id] && newArticles[data.id].active;
        var article = parseCachedArticle(data, payload.source.dataIndex, active, payload.projCode);

        if (article.active) {
          article.olFeature.set('active', true);
        }

        if (currentArticles[article.id]) {
          article.sources = article.sources.concat(currentArticles[article.id].sources);
        }

        newArticles[article.id] = article;
      });
      var loadState = {};
      loadState[payload.source.dataIndex] = Object.assign({}, state.loadState[payload.source.dataIndex], {
        isLoaded: true,
        isLoading: false
      });
      return Object.assign({}, state, {
        loading: false,
        articles: newArticles,
        loadState: Object.assign({}, state.loadState, loadState)
      });
    } else if (payload.data.features) {
      var _currentArticles = state.articles || {};

      Object.values(_currentArticles).forEach(function (article) {
        if (article.active || !article.olFeature || containsCoordinate(payload.extent, article.olFeature.getGeometry().getFirstCoordinate())) {
          newArticles[article.id] = article;
        } else if (article.olFeature) {
          delete article.olFeature;
        }
      });
      payload.data.features.forEach(function (data) {
        data.globalId = data.id;
        data.id = payload.source.dataIndex + '_' + data.globalId.substring(data.globalId.indexOf('_') + 1);

        if (payload.source.value.api === 'flickr') {
          data.properties.content = data.properties.description._content;
        }

        var active = newArticles[data.id] && newArticles[data.id].active;
        newArticles[data.id] = data;
        data.active = active;
        data.sources = [payload.source.dataIndex];

        if (_currentArticles[data.id]) {
          data.sources = data.sources.concat(_currentArticles[data.id].sources);
        }
      });
      olUtils.readFeaturesFromGeoJson(payload.data).forEach(function (feature) {
        feature.getGeometry().transform('EPSG:4326', payload.projCode);
        var article = newArticles[feature.getId()];

        if (article.olFeature) {
          return;
        }

        feature.set('title', article.properties.title);
        article.olFeature = feature;

        if (article.active) {
          feature.set('active', true);
        }

        feature.set('clusterGroup', payload.source.dataIndex);
      });
      var _loadState = {};
      _loadState[payload.source.dataIndex] = Object.assign({}, state.loadState[payload.source.dataIndex], {
        isLoaded: true,
        isLoading: false
      });
      return Object.assign({}, state, {
        loading: false,
        articles: newArticles,
        loadState: Object.assign({}, state.loadState, _loadState)
      });
    } else {
      return state;
    }
  },
  LOAD_THEME_ARTICLES: function LOAD_THEME_ARTICLES(state, _ref2) {
    var payload = _ref2.payload;

    if (!payload.articles) {
      return Object.assign({}, state, {
        loading: false
      });
    } else {
      var currentArticles = state.articles || {};
      var newArticles = {};
      Object.values(currentArticles).forEach(function (article) {
        if (article.active || !article.olFeature || article.olFeature.getGeometry().intersectsExtent(payload.extent) && article.sourceDataIndex !== payload.source.dataIndex) {
          newArticles[article.id] = article;
        } else if (article.olFeature) {
          delete article.olFeature;
        }
      });
      payload.articles.forEach(function (article) {
        article.active = newArticles[article.id] && newArticles[article.id].active;
        article.sourceDataIndex = payload.source.dataIndex;

        if (currentArticles[article.id]) {
          article.sources = article.sources.concat(currentArticles[article.id].sources);
        }

        newArticles[article.id] = article;
      });
      var loadState = {};
      loadState[payload.source.dataIndex] = Object.assign({}, state.loadState[payload.source.dataIndex], {
        isLoaded: true,
        isLoading: false
      });
      return Object.assign({}, state, {
        loading: false,
        articles: newArticles,
        loadState: Object.assign({}, state.loadState, loadState)
      });
    }
  },
  LOADING_SOURCE: function LOADING_SOURCE(state, _ref3) {
    var payload = _ref3.payload;
    var loadState = {};
    loadState[payload.source.dataIndex] = {
      isLoaded: false,
      isLoading: true,
      mapCenter: payload.mapCenter,
      mapZoom: payload.mapZoom,
      filterColumns: payload.filterColumns
    };
    return Object.assign({}, state, {
      loading: true,
      loadState: Object.assign({}, state.loadState, loadState)
    });
  },
  ARTICLE_LOADING: function ARTICLE_LOADING(state, _ref4) {
    var payload = _ref4.payload;
    return Object.assign({}, state, {
      articleId: payload.id,
      articleLoading: true,
      articleError: false
    });
  },
  ARTICLE_LOADED: function ARTICLE_LOADED(state, _ref5) {
    var payload = _ref5.payload;

    if (payload.cached) {
      var newArticles = Object.assign({}, state.articles);
      newArticles[payload.id] = parseCachedArticle(payload.data, payload.dataIndex, false, payload.projCode);
      return Object.assign({}, state, {
        articleLoading: false,
        articles: newArticles
      });
    } else if (payload.data) {
      var _newArticles = Object.assign({}, state.articles);

      payload.data.id = payload.id;
      var article = _newArticles[payload.id] = payload.data;
      var featureArray = olUtils.readFeaturesFromGeoJson(payload.data);
      var feature = featureArray.length > 0 ? featureArray[0] : undefined;

      if (feature) {
        feature.getGeometry().transform('EPSG:4326', payload.projCode);
        feature.set('title', article.properties.title);
        article.olFeature = feature;
      }

      return Object.assign({}, state, {
        articleLoading: false,
        articles: _newArticles
      });
    } else {
      return Object.assign({}, state, {
        articleLoading: false,
        articles: {},
        articleError: true
      });
    }
  },
  THEME_ARTICLE_LOADED: function THEME_ARTICLE_LOADED(state, _ref6) {
    var payload = _ref6.payload;

    if (payload.article) {
      var newArticles = Object.assign({}, state.articles);
      newArticles[payload.id] = payload.article;
      return Object.assign({}, state, {
        articleLoading: false,
        articles: newArticles
      });
    } else {
      return Object.assign({}, state, {
        articleLoading: false,
        articles: {},
        articleError: true
      });
    }
  },
  SET_ACTIVE_SOURCES: function SET_ACTIVE_SOURCES(state, _ref7) {
    var payload = _ref7.payload;
    return Object.assign({}, state, {
      activeSources: payload.activeSources || ''
    });
  },
  RESET_LOAD_STATE: function RESET_LOAD_STATE(state) {
    return Object.assign({}, state, {
      loading: false,
      articleId: null,
      articleLoading: false,
      activeSources: '',
      articleError: false
    });
  }
}, {
  loading: false,
  articleId: null,
  articleLoading: false,
  activeSources: '',
  articleError: false,
  loadState: {},
  articles: {}
});